import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = 'https://admin.1oneplus.net/api';

export const fetchPageContent = createAsyncThunk(
    'pages/fetchContent',
    async ({ pageName, lang }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BASE_URL}/pages/${pageName}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'lang': lang || 'en',
                },
            });

            if (response.data.status === false) {
                return rejectWithValue(response.data.message || 'Failed to fetch page content');
            }

            return { pageName, data: response.data.data };
        } catch (error) {
            if (error.response) {
                return rejectWithValue(error.response.data.message || 'Failed to fetch page content');
            }
            return rejectWithValue(error.message || 'Network error');
        }
    }
);
